export enum EmailCaptureTestIds {
    SECTION = 'EmailCapture__section',
}
